/** The physical page size the on-screen preview and browser print dialog
 * target. Purely a preview/print concern — the exported PDF/PNG artifact
 * from ExportContainerLabels always renders at 4 x 6, the physical label
 * stock size, regardless of this setting. */
export type LabelSizeOption = "4x6" | "letter";

/** "Small"/"Large" name the print size by feel, not by dimension -- the
 * dimensions themselves ("4 × 6 in", "Letter") moved to the Download
 * cluster's caption and no longer need their own label here. */
export const LABEL_SIZE_OPTIONS: { value: LabelSizeOption; label: string }[] = [
  { value: "4x6", label: "Small" },
  { value: "letter", label: "Large" },
];

export const PREVIEW_SIZE_BY_LABEL_SIZE: Record<LabelSizeOption, "sm" | "lg"> = {
  "4x6": "sm",
  letter: "lg",
};
